import React from "react";
import { FaExclamationTriangle, FaSyncAlt } from "react-icons/fa";
import { formatCurrency } from "./commissionDetailConstants";

/**
 * Shown when inquiry tuition no longer matches the saved commission plan tuition.
 */
function TuitionFeeSyncBanner({
  planCommissionableTuitionFee,
  latestCommissionableTuitionFee,
  currency = "AUD",
  busy = false,
  onSync,
}) {
  return (
    <div className="mb-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 shadow-sm">
      <div className="flex flex-wrap items-start gap-2.5">
        <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-amber-500 text-white">
          <FaExclamationTriangle size={12} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="mb-0 text-[13px] font-semibold text-amber-900">
            Commissionable tuition fee changed — update commission plan
          </p>
          <p className="mb-0 mt-0.5 text-[12px] text-amber-800/90">
            Inquiry commissionable tuition is now{" "}
            <strong>
              {formatCurrency(latestCommissionableTuitionFee, currency)}
            </strong>
            , but the commission plan still uses{" "}
            <strong>
              {formatCurrency(planCommissionableTuitionFee, currency)}
            </strong>
            . Update the plan to recalculate expected commission
            {Number(latestCommissionableTuitionFee) >
            Number(planCommissionableTuitionFee)
              ? ". Non-invoiced installments will be increased where possible"
              : Number(latestCommissionableTuitionFee) <
                  Number(planCommissionableTuitionFee)
                ? ". Non-invoiced installments will be reduced to fit (invoiced rows stay unchanged)"
                : ""}
            .
          </p>
        </div>
        <button
          type="button"
          disabled={busy}
          onClick={onSync}
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md bg-amber-600 px-2.5 text-[11px] font-semibold text-white hover:bg-amber-700 disabled:cursor-wait disabled:opacity-60"
          style={{ border: "none" }}
        >
          <FaSyncAlt size={10} />
          {busy ? "Updating…" : "Update plan"}
        </button>
      </div>
    </div>
  );
}

export default TuitionFeeSyncBanner;
